module.exports = __webpack_public_path__ + "03_medium_black.bd660f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_medium_black.png
// module id = YGcS
// module chunks = 0